function MusicDetailPlayerObserver() {
  this.handlers = [];
}

MusicDetailPlayerObserver.prototype = {
  subscribe: function (fn) {
    this.handlers.push(fn);
  },

  unsubscribe: function (fn) {
    this.handlers = this.handlers.filter(
      function (item) {
        if (item !== fn) {
          return item;
        }
      }
    );
  },

  fire: function (o, thisObj) {
    var scope = thisObj || window;
    this.handlers.forEach(function (item) {
      item.call(scope, o);
    });
  }
};

const musicObserver = new MusicDetailPlayerObserver();
export default musicObserver;



// WEBPACK FOOTER //
// ./src/utils/MusicDetailPlayerObserver.js